<template>
  <div class="navbar">
    <a-menu mode="inline" :default-selected-keys="[defaultKey]">
      <template v-for="(item, index) in navList">
        <a-menu-item :key="index" v-if="!item.subMenu" @click="onClickMenu(item)">
          <div class="flex align-center item">
            <span class="nav-icon-box">
              <img :src="item.icon" alt="" class="nav-icon">
            </span>
            <span class="nav-text">{{ item.label }}</span>
            <span class="nav-arrow">›</span>
          </div>
        </a-menu-item>
        <a-sub-menu :key="index + ''" v-else>
          <span slot="title">
            <span>{{ $t('Navbar.' + item.label) }}</span>
          </span>
          <a-menu-item :key="index + '-' + subInd" v-for="(sub, subInd) in item.subMenu" @click="onClickMenu(sub)">
            <div class="flex align-center">
              <span class="dot"></span>
              {{ $t('Navbar.' + sub.label) }}
            </div>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>


  </div>
</template>

<script>
export default {
  data() {
    return {
      
      navList: [
        { label: this.$t("Common.DASHBOARD"), path: '/', icon: require('@/assets/icon-favorite-chart.svg') },
        { path: '/wallet', label: this.$t("Common.WALLET"), icon: require('@/assets/icon-wallet.svg') },
        { path: '/portfolio', label: this.$t("Common.配套"), icon: require('@/assets/icon-products.svg') },
        { path: '/referral', label: this.$t("Common.REFERRAL PROGRAM"), icon: require('@/assets/icon-network.svg') },
      ],
      defaultKey: 0
    }
  },
  methods: {
    onClickMenu({ label, path }) {
      if(path === 'logout') {
        this.onLogout();
      } else {
        this.$store.commit('SET_StorePageTitle', label);
        this.$router.push(path);
      }
    },
    onLogout() {
      localStorage.removeItem('token');
      this.$router.replace('/login');
    },
  },
  created() {
    let path = this.$route.path;
    this.navList.forEach((item, index) => {
      if (item.path) {
        if (path === item.path) {
          this.defaultKey = index;
          this.$store.commit('SET_StorePageTitle', item.label);
        }
      } else {
        item.subMenu.forEach((sub, subInd) => {
          if (sub.path === path) {
            this.$store.commit('SET_StorePageTitle', sub.label);
            this.defaultKey = index + '-' + subInd;
          }
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
/* ============================================================
   💎 侧边导航栏 — 深色金融专业风
   - 全大写 + letter-spacing
   - 图标盒 + 选中态深色玻璃 + 品牌渐变描边 + 左侧光柱
   ============================================================ */

.navbar {
  overflow: hidden;
  position: relative;
  padding: 6px 4px;
}

/* --- ant-menu 基础透明 --- */
::v-deep .ant-menu {
  background: transparent !important;
  border: 0 !important;
}

/* --- 菜单项 --- */
::v-deep .ant-menu-item {
  position: relative;
  height: 52px !important;
  line-height: 52px !important;
  margin: 6px 0 !important;
  padding: 0 14px !important;
  border-radius: 10px !important;
  font-size: 12px !important;
  color: #8b949e !important;
  background: transparent !important;
  transition: all 200ms cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;

  /* 左侧 3px 隐藏光柱（hover/active 时亮起） */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary) 100%);
    box-shadow: 0 0 12px rgba(239, 192, 42, 0.6);
    opacity: 0;
    transform: scaleY(0.4);
    transition: all 220ms cubic-bezier(0.16, 1, 0.3, 1);
  }

  &::after { border-right: 0 !important; }

  &:hover {
    color: #e6edf3 !important;
    background: rgba(239, 192, 42, 0.06) !important;
    transform: translateX(2px);

    &::before { opacity: 0.5; transform: scaleY(0.7); }

    .nav-icon-box {
      background: rgba(239, 192, 42, 0.12);
      border-color: rgba(239, 192, 42, 0.3);
    }
    .nav-icon { filter: brightness(0) saturate(100%) invert(72%) sepia(38%) saturate(561%) hue-rotate(40deg) brightness(96%) contrast(94%); }
    .nav-arrow { opacity: 0.6; transform: translateX(2px); }
  }
}

/* --- 菜单内容布局 --- */
.item {
  white-space: nowrap;
  overflow: hidden;
  flex-wrap: nowrap;
  font-weight: 600;
  gap: 12px;
}

/* --- 图标盒（深色圆角矩形容器） --- */
.nav-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: all 220ms cubic-bezier(0.16, 1, 0.3, 1);
}

.nav-icon {
  width: 16px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(60%) sepia(8%) saturate(220%) hue-rotate(195deg) brightness(92%) contrast(86%);
  transition: filter 220ms cubic-bezier(0.16, 1, 0.3, 1);
}

/* --- 菜单文字（全大写） --- */
.nav-text {
  flex: 1 1 auto;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: inherit;
}

/* --- 右侧箭头（未选中时隐藏，hover 时淡入） --- */
.nav-arrow {
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
  color: #484f58;
  opacity: 0;
  transform: translateX(-4px);
  transition: all 200ms cubic-bezier(0.16, 1, 0.3, 1);
}

/* --- 选中态：深色玻璃 + 品牌渐变描边 --- */
::v-deep .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  position: relative;
  background: linear-gradient(135deg, rgba(239, 192, 42, 0.18) 0%, rgba(239, 192, 42, 0.12) 100%) !important;
  color: #e6edf3 !important;
  border-radius: 10px;
  font-weight: 700;
  box-shadow:
    inset 0 0 0 1px rgba(239, 192, 42, 0.45),
    0 4px 16px rgba(239, 192, 42, 0.15);

  &::before {
    opacity: 1 !important;
    transform: scaleY(1) !important;
  }

  .nav-icon-box {
    background: linear-gradient(135deg, rgba(239, 192, 42, 0.25) 0%, rgba(239, 192, 42, 0.2) 100%);
    border-color: rgba(239, 192, 42, 0.5);
    box-shadow: 0 0 12px rgba(239, 192, 42, 0.35);
  }
  .nav-icon { filter: brightness(0) saturate(100%) invert(72%) sepia(58%) saturate(561%) hue-rotate(40deg) brightness(96%) contrast(94%); }
  .nav-arrow { opacity: 1; color: var(--color-primary); transform: translateX(0); }
  .nav-text { color: #e6edf3; }

  &::after { border-right: 0 !important; }
}

/* --- 子菜单（暂未使用，预留） --- */
::v-deep .ant-menu-submenu-selected { color: #e6edf3 !important; }
::v-deep .ant-menu-sub {
  background: transparent !important;
  border: 0;
}

::v-deep .ant-menu-submenu-title:hover {
  color: #e6edf3 !important;

  .ant-menu-submenu-arrow {
    &::after, &::before { background: var(--color-primary) !important; }
  }
}

::v-deep .ant-menu-submenu-title {
  .ant-menu-submenu-arrow {
    &::after, &::before { background: var(--color-primary) !important; }
  }
}

.ant-menu-submenu {
  color: #8b949e;
  font-weight: 600;

  &:hover {
    font-weight: 600;
    color: #e6edf3;
  }

  &::after { border-right: 0 !important; }

  .ant-menu-submenu-title {
    color: #8b949e;
    font-weight: 600;

    &:hover {
      font-weight: 600 !important;
      color: #e6edf3 !important;
    }

    &::after { border-right: 0 !important; }
  }
}

/* 折叠态 */
::v-deep .ant-menu-inline-collapsed > .ant-menu-item {
  padding: 0 20px !important;
}

/* 子菜单圆点 */
.dot {
  margin-right: 10px;
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #8b949e;
  border-radius: 50%;
  transition: background-color 200ms;
}

::v-deep .ant-menu-item-selected .dot {
  background-color: var(--color-primary);
  box-shadow: 0 0 8px rgba(239, 192, 42, 0.6);
}

/* --- 移动端适配 --- */
@media screen and (max-width: 576px) {
  .nav-text {
    font-size: 11px;
    letter-spacing: 1px;
  }

  .nav-icon-box {
    width: 26px;
    height: 26px;
    flex-basis: 26px;
  }
  .nav-icon { width: 14px; height: 14px; }

  ::v-deep .ant-menu-inline .ant-menu-item {
    font-size: 11px !important;
    margin-bottom: 0 !important;
    height: 46px !important;
    line-height: 46px !important;
    padding: 0 10px !important;
  }

  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    font-size: 11px !important;
  }
}
</style>